import BaseEndpoint from '@spa/apps/trustup-pro-base-js/endpoints/BaseEndpoint';
import CalendarEventCollection from '../collections/CalendarEventCollection';
import CalendarEvent from '../models/CalendarEvent';

export default class CalendarEventEndpoint extends BaseEndpoint
{

    constructor()
    {
        super(
            'timetracker',
            {
                'path': 'calendar-events',
                'responseKey': 'event',
                'responseKeyPlural': 'events',
                'modelClass': CalendarEvent,
                'collectionClass': CalendarEventCollection
            }
        );
    }

    async daily(day)
    {
        return await this.index({day}, `calendar-events/daily`);
    }

    async predictions({start, end, worksites = null, users = null})
    {
        let data = await this.request(`${this.path}/predictions?start=${start}&end=${end}&worksites=${worksites}&users=${users}`);

        data.predictions = new CalendarEventCollection(
            data.predictions
        );
        
        return data;
    }

}